export default __webpack_public_path__ + "static/media/GHSI Independent Director Policy.22b641be.pdf";